import React from "react";

export function handleMask(
	type: string,
	e: React.ChangeEvent<HTMLInputElement>
) {
	let inputValue = e.currentTarget.value;
	const mascaras = {
		CPF: e.currentTarget.value.replace(
			/(\d{3})(\d{3})(\d{3})(\d{2})/,
			"$1.$2.$3-$4"
		),
		CellNumber: e.currentTarget.value
			.replace(/[^\d]/g, "")
			.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3"),
	};

	if (type === "cpf") {
		e.currentTarget.maxLength = 11;
		inputValue = mascaras.CPF;
		e.currentTarget.value = inputValue;
		console.log(inputValue);
		return e;
	}
	if (type === "telefone") {
		e.currentTarget.maxLength = 11;
		inputValue = mascaras.CellNumber;
		e.currentTarget.value = inputValue;
		return e;
	}
	e.currentTarget.maxLength = 50;
	return e;
}
